/**
 * @Email : azapata@ibl.mx
 * @Author: Ferro Zapata Arnulfo
 * @jobTittle: Full Stack Developer
 *
 */
import Subtitle from "../../../../components/Header/Subtitle";
import CustomTable from "../../../../components/table/CustomTable";
import DeleteModal from "../../../Modals/DeleteModal";
import ButtonSubAction from "../../../../components/buttons/ButtonSubAction";
import ButtonAction from "../../../../components/buttons/ButtonAction";
import {TrashOutlineIcon} from "../../../../components/buttons/IconButtons";
import {DepartmentExpandedRowApp} from "../Funtionallity/DepartmentExpandedRowApp";
import ManageEmployeeDepartment from "./ManageEmployeeDepartment";
import { permissionObj } from "../../../../Helpers/permission";

/**
 * @Email : azapata@ibl.mx
 * @Author: Ferro Zapata Arnulfo
 * @jobTittle: Full Stack Developer
 *
 */

const RenderExpandedRow = (row) => {
    const {
        selectedList,
        setData,
        show,
        setShow,
        manageShow,
        setManageShow,
        deleteSelectedManageUser,
        thead,
        tbody,
        handleCheckboxChange,
        handleDeleteAll,
        pagination,
        tableId,
        searchResults,
        setSelectedList,
        setModified,
        modified,
        selectedId, setSelectedId,
        DEV,
        permission
    } = DepartmentExpandedRowApp(row)

    return (
        <>
            <Subtitle
                name={'users_in_the_department'}
                divStack={
                    <>
                        {(DEV || permission?.includes(permissionObj?.WEB_DEPARTMENT_MANAGE_USERS)) && (
                            <ButtonSubAction
                                id='btn_dp_add_employees'
                                name='add_employees'
                                onClick={() => {
                                    setManageShow(true);
                                setSelectedId(row?.row?.id)
                                }}
                            />
                        )}
                    </>
                }
            >
                {selectedList?.length > 0 && (DEV || permission?.includes(permissionObj?.WEB_DEPARTMENT_DELETE)) && (
                    <ButtonAction
                        id='btn_szd_delete'
                        name='delete'
                        className='btn-icon-delete'
                        disabled={selectedList?.length === 0}
                        Icon={TrashOutlineIcon}
                        onClick={() => {
                            setShow(true);
                            const data = {
                                id: row?.row?.id,
                                Tuser: searchResults?.totalElements,
                                Dname: row?.row?.name,
                            };
                            setData(data);
                        }}
                        splitName={false}
                    />
                )}
            </Subtitle>
            <CustomTable
                tableId={tableId}
                checkbox={DEV || permission?.includes(permissionObj?.WEB_DEPARTMENT_MANAGE_USERS)}
                checkboxTitle={'de_/_select_all'}
                isAllChecked={selectedList?.length !== 0}
                onChangeCheckbox={handleDeleteAll}
                thead={thead}
                tbody={tbody}
                columnActions={false}
                handleCheckboxChange={handleCheckboxChange}
                selectedList={selectedList}
                withoutHeight={true}
            />
            {pagination()}
            <DeleteModal
                show={show}
                onHide={() => {
                    setShow(false)
                }}
                onClickFn={() => deleteSelectedManageUser(selectedList)}
                data={selectedList}
                description={'are_you_sure_you_want_to_remove'}
                title_modal={'delete'}
                element_modal={'employee'}
                isReset={setSelectedList}
            />

            { manageShow &&
                <ManageEmployeeDepartment
                    show={manageShow}
                    onHide={() => setManageShow(false)}
                    selectedId={selectedId}
                    setModified={setModified}
                    modified={modified}
                />
            }
        </>
    )
};

export default RenderExpandedRow
